import PropTypes from 'prop-types'

import Controls from '@aytm/app/stats/page/question-views/mn/components/controls/Controls'
import ViewModeDropdown from '@aytm/app/stats/page/question-views/mn/components/controls/ViewModeDropdown'

const MenuMetricsControls = ({ title, options, viewMode, collapsed, onModelChange, onToggle }) => (
  <Controls title={title} collapsed={collapsed} onToggle={onToggle}>
    <ViewModeDropdown
      options={options}
      value={viewMode}
      label={title ? `${title} view mode` : undefined}
      onChange={onModelChange}
    />
  </Controls>
)

MenuMetricsControls.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  viewMode: PropTypes.string,
  collapsed: PropTypes.bool,
  onModelChange: PropTypes.func,
  onToggle: PropTypes.func
}

MenuMetricsControls.displayName = 'MenuMetricsControls'

export default MenuMetricsControls
